import {disablePageScroll, enablePageScroll} from "./helpers";
import {initImageZoom} from "./zoom-gallery";

;(function ($) {
  "use strict";

  $(document).ready(function () {
    modalInit();
  });
})(jQuery);

var globalModal = $('#global-modal');
var modalState = {};
var $navigationToggle = $('.js-navigation-toggle');

function modalInit() {

  // when trigger occurs, run close modal function to close open modal e.g. to close search modal if menu open is triggered
  $navigationToggle.on("closeModal", function () {
    closeModal($('#global-search-wrapper'), 'global-search-wrapper');
  });

  $('.modal').show().hide();

  $('.js-modal-trigger').on('click', function (e) {
    e.preventDefault();

    var sourceElem = $(this);
    var targetId = sourceElem.data('modal-target');
    if (!targetId) targetId = 'global-modal';

    var targetModal = ($('#' + targetId).length > 0) ? $('#' + targetId) : globalModal;
    modalState[targetId] = {source: sourceElem};
    openModal(targetModal);
  });

  $('.modal .close-button').on('click', function (e) {
    e.preventDefault();

    var targetModal = $(this).closest('.modal');

    closeModal(targetModal);
  });
}

function openModal(targetModal) {
  var targetId = targetModal.attr('id');

  // prevent page scroll
  disablePageScroll();

  // update HTML / Attributes
  $('body').addClass('modal-open');

  // show modal associated with control
  targetModal.fadeIn();

  // update aria information on control used to open modal
  $('[data-modal-target = ' + targetId + ']').attr('aria-expanded', 'true');

  // focus on relevant modal
  $('#header-search-form_Search').focus();


  if (modalState[targetId].source.data('ajax-action')) {

    var contentHolder = targetModal.find('.modal-content-holder');
    if (contentHolder.length) {
      var loading = $("<div class='content-holder'><p class='txt-center loading'>loading...</p></div>");
      contentHolder.html('').append(loading);
      var url = modalState[targetId].source.data('ajax-action');
      $.ajax(url, {
        dataType: "html",
        error: function (jqXHR, textStatus, exception) {
          contentHolder.append($("<div class='content-holder'><p class='txt-center loading'>Error loading</p></div>"));
        },
        success: function (html, textStatus, jqXHR) {
          contentHolder.append($(html));

          // Bind the close button handler after it has been inserted into DOM
          targetModal.find('.close-button').on('click', function (e) {
            e.preventDefault();
            closeModal(targetModal);
          });
        },
        complete: function (jqXHR, textStatus) {
          loading.remove();
        }
      });
    }

  }

  if (modalState[targetId].source.data('image-zoom')) {
    var startImg = modalState[targetId].source.data('image-url');
    initImageZoom(startImg);
  }


  // close when depressing the Esc key (if main Menu is not open)
  // TO DO
  $(document).on('keyup.modal', function (e) {
    if (e.which == 27 && !$('body').hasClass('menu-open')) { // escape key maps to keycode `27`
      closeModal(targetModal);
    }
  });

}

export function closeModal(targetModal, attr) {
  var targetId = attr || targetModal.attr('id');

  // update HTML / Attributes
  $('body').removeClass('modal-open');

  // hide modal associated with control
  targetModal.fadeOut();

  // update aria information on all controls linked to open modal
  $('[data-modal-target = ' + targetId + ']').attr('aria-expanded', 'false');

  // enable page scroll (if menu not open at same time)
  if (!$('body').hasClass('menu-open')) enablePageScroll();

  // return focus to original modal trigger
  if (modalState[targetId]) {
    modalState[targetId].source.focus();
    modalState[targetId] = null;
  }
}
